import React from 'react';
import { useDispatch } from 'react-redux';
import { SectionNavbar } from '@sunrun/component-library';
import withSizes from 'react-sizes';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Color } from '@sunrun/mui-theme';
import { toggleSideDrawer } from '../../redux/modules/app';
import { ChatControlButton } from '../support/ChatButton';
import { useOpportunity, useIsEVChargerProspect } from '../../hooks/useUser';
import mapSizesToProps from './utilities/mapSizesToProps';
import { PRODUCT_BACKGROUND } from './constants/_colors';

const Header = ({
  backgroundColor,
  color,
  showBackIcon,
  isMobile,
  isSticky,
  goBackLink,
  showMainIconMobile,
  subtitle,
  subtitleHasInfoIcon,
  title,
  withChat,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const oppty = useOpportunity();
  const isEVChargerProspect = useIsEVChargerProspect();
  const drawerToggle = () => {
    dispatch(toggleSideDrawer());
    return false;
  };

  const goBack = () => {
    history.goBack();
  };

  const goToLink = link => {
    history.push(link);
  };

  const navbarProps = {};
  if (showMainIconMobile) {
    navbarProps.onClickLogo = drawerToggle;
  }
  if (showBackIcon) {
    navbarProps.onClickBack = goBackLink ? () => goToLink(goBackLink) : goBack;
  }
  if (withChat && isMobile && oppty && !oppty.isMultiFamilyHome && !isEVChargerProspect) {
    navbarProps.additional = <ChatControlButton />;
  }

  return (
    <SectionNavbar.MainSection
      backgroundColor={backgroundColor}
      color={color}
      isSticky={isMobile && isSticky ? true : undefined}
      subtitle={subtitle}
      subtitleHasInfoIcon={subtitleHasInfoIcon}
      title={title}
      {...navbarProps}
    />
  );
};

Header.propTypes = {
  /** The color of the bakground */
  backgroundColor: PropTypes.string,
  /** Color of the title */
  color: PropTypes.string,
  /** Back arrow goes to this link instead of going back 1 in router history */
  goBackLink: PropTypes.string,
  /** Determines if is mobile view */
  isMobile: PropTypes.bool.isRequired,
  /** Determines if header should stick to top of page while scrolling */
  isSticky: PropTypes.bool,
  /** Indicates if the back button should be displayed */
  showBackIcon: PropTypes.bool,
  /** Indicates if the main icon should be shown on mobile */
  showMainIconMobile: PropTypes.bool,
  /** content to display under the title */
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Indicates if the info icon should show in the subtitle section */
  subtitleHasInfoIcon: PropTypes.bool,
  /** Text to display on the header */
  title: PropTypes.string.isRequired,
  /**  Determines if we need to show chat button */
  withChat: PropTypes.bool,
};

Header.defaultProps = {
  backgroundColor: PRODUCT_BACKGROUND,
  color: Color.BLACK,
  goBackLink: null,
  isSticky: false,
  showBackIcon: false,
  showMainIconMobile: false,
  subtitle: null,
  subtitleHasInfoIcon: false,
  withChat: true,
};

export default withSizes(mapSizesToProps)(Header);
